<template>
  <v-container class="pl-0">
    <div class="text-caption">{{ label }}</div>
    <v-row dense>
      <v-col cols="1">
        <v-file-input
          v-model="input"
          show-size
          multiple
          hide-input
          :clearable="false"
          :label="label"
        />
      </v-col>

      <v-col cols="10">
        <v-row v-for="(file, index) in input" :key="index" dense>
          <v-col cols="6">
            <v-chip>
              {{ file.name }}
            </v-chip>
          </v-col>
          <v-col cols="6">
            <span class="pl-5 red--text">{{ file.message }}</span>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12">
            <v-chip-group column>
              <v-chip
                v-for="(file, index) in storedFiles"
                :key="index"
                @click="loadFile({ uuid: file.uuid })"
                close
                @click:close="detachDialog(file.uuid)"
              >
                {{ file.name }}
              </v-chip>
            </v-chip-group>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="1">
        <v-progress-circular
          v-if="isSaving || isLoading"
          indeterminate
        ></v-progress-circular>
      </v-col>
    </v-row>
    <v-dialog v-model="dialog" max-width="500">
      <v-card>
        <v-card-title>Вы действительно хотите удалить этот файл?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="blue darken-1" @click="dialog = false">
            Отмена
          </v-btn>
          <v-btn text color="blue darken-1" @click="detach"> Да </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import { ACTIONS, GETTERS, MUTATIONS } from "@/store";

export default {
  name: "AttachedFiles",
  props: {
    label: { type: String, default: "" },
    fieldName: { type: String, required: true },
    cardId: { type: Number, required: true },
    uNumber: { required: true },
  },
  data: () => ({
    result: [],
    dialog: false,
    uuid: "",
  }),
  computed: {
    ...mapGetters({
      card: GETTERS.CARD_DATA,
      isSaving: GETTERS.IS_FILE_SAVING,
      isLoading: GETTERS.IS_FILE_LOADING,
    }),

    allFiles() {
      return this.card[this.fieldName] || [];
    },

    storedFiles() {
      return this.allFiles.filter((item) => item.uuid);
    },

    filesSet() {
      const filesSet = new Set();
      this.storedFiles.forEach((item) => filesSet.add(this.getKey(item)));
      return filesSet;
    },

    input: {
      get() {
        return this.allFiles.filter((item) => !item.uuid);
      },
      set(value) {
        // оставить в value то, чего нет в filesSet
        const res = value.filter(
          (item) => !this.filesSet.has(this.getKey(item))
        );

        if (!res.length) {
          return;
        }
        const mapped = res.map((item) => ({
          file: item,
          lastModified: item.lastModified,
          name: item.name,
          size: item.size,
          type: item.type,
        }));
        this.modify({ [this.fieldName]: mapped });
        this.saveFiles(this.fieldName);
      },
    },
  },
  methods: {
    ...mapActions({
      saveFiles: ACTIONS.SAVE_CARD_FILES,
      loadFile: ACTIONS.LOAD_CARD_FILE,
      detachFile: ACTIONS.DETACH_CARD_FILE,
    }),
    ...mapMutations({ modify: MUTATIONS.MODIFY_CARD_DATA }),

    detachDialog(uuid) {
      this.dialog = true;
      this.uuid = uuid;
    },

    detach() {
      this.detachFile({
        uuid: this.uuid,
        fieldName: this.fieldName,
        cardId: this.cardId,
      });
      this.dialog = false;
    },
    getKey(file) {
      return JSON.stringify({
        name: file.name,
        lastModified: file.lastModified,
        size: file.size,
        type: file.type,
      });
    },
  },
};
</script>
